import { serverTimestamp } from "firebase/database";
import moment from "moment"

export function formatDate(date: any, format: string) {
    return moment(date).format(format);
}
 
export function getCurrentDate(){
    let time=serverTimestamp()
   return formatDate(time,"DD-MM-YYYY")
  }

export function formatDateWithLocalTimeZone(date: any, format: string) {
    return moment(new Date(date)).parseZone().local().format(format)
}
export function checkIsWeekend(date:any){
   let isWeekend = ['Saturday', 'Sunday'].includes(formatDateLikeCalendar(date, "dddd"));
return isWeekend
}
export function formatDateLikeCalendar(date: any, format:string) {
    const today = moment().startOf('day');
    const inputDate = moment(date).startOf('day');
    const diffDays = inputDate.diff(today, 'days');

    if (diffDays === 0) {
        return "Today";
    } else if (diffDays === 1) {
        return "Tomorrow";
    } else if (diffDays === -1) {
        return "Yesterday";
    } else {
        return moment(date).format(format);
    }
}


export const removeSecondsFromTime = (timeString: string): any => {
    if (timeString) {
        let [time, period] = timeString.split(' ');
        let timeParts = time.split(':');
        timeParts.pop();
        return timeParts.join(':') + ' ' + period;
    }
    return null;
};
export const formatTime = (time: any): string => {
    const formattedHours = time.hours < 10 ? `0${time.hours}` : `${time.hours}`;
    const formattedMinutes = time.minutes < 10 ? `0${time.minutes}` : `${time.minutes}`;
    const formattedSeconds = time.seconds < 10 ? `0${time.seconds}` : `${time.seconds}`;

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const formatTimerDuration = (duration: string):string => {
    const [hours, minutes, seconds] = duration.split(':').map(part => parseInt(part, 10));

    let roundedMinutes = minutes;
    let extraHour = 0;

    if (seconds >= 30) {
        roundedMinutes += 1;
    }

    if (roundedMinutes >= 60) {
        roundedMinutes = 0;
        extraHour = 1;
    }

    const formattedHours = (hours + extraHour).toString().padStart(2, '0');
    const formattedMinutes = roundedMinutes.toString().padStart(2, '0');

    return `${formattedHours} hrs ${formattedMinutes} mins`;
};

export function calculateTotalDuration(timeRecords: any) {
    console.log(timeRecords);
    
    const totalSeconds = timeRecords?.reduce((acc, record) => {
      const [hours, minutes, seconds] = record.duration?.split(':').map(Number) || [0, 0, 0];;
      return acc + (hours * 3600) + (minutes * 60) + seconds;
    }, 0);

    const totalDurationHours = Math.floor(totalSeconds / 3600);
    const totalDurationMinutes = Math.floor((totalSeconds % 3600) / 60);
    const totalDurationSeconds = totalSeconds % 60;
    const totalDuration = `${totalDurationHours.toString().padStart(2, '0')}:${totalDurationMinutes.toString().padStart(2, '0')}:${totalDurationSeconds.toString().padStart(2, '0')}`;

    return totalDuration;
  }